module.exports = __webpack_public_path__ + "images/assets/e42acf1c99c0c7fe1ae88c3d7c9f18f5.svg";